import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, TextField, Checkbox } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UploadIcon from '@mui/icons-material/Upload';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { useSelectedRows } from './tabla/SelectedRowsContext';
import axiosInstancePromise from '../general/axiosConfig';
import {styleDocExplorer} from '../estilo/Main';

const DocumentExplorer = () => {
  const [path, setPath] = useState('');
  const [items, setItems] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);
  const [newFileName, setNewFileName] = useState('');
  const { selectedFiles, setSelectedFiles } = useSelectedRows();
  const subdomain = window.location.hostname.split('.')[0];
  const basePath = `/var/www/html/archivo-kai/${subdomain}`;


  const downloadFile = async (fileName) => {
    if (!path) {
      console.error("El parámetro 'path' está vacío");
      return;
    }
  
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.get(`/soportes-download/${fileName}`, {
        params: { path },
        responseType: 'blob', // Importante para manejar archivos correctamente
      });
  
      // Crear un enlace para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // Liberar memoria
  
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };

  const fetchFiles = async () => {
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.get('/soportes-listar', { params: { path } });
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, [path]);

  const handleSelectFile = (fileName) => {
    setSelectedFiles((prevSelected) =>
      prevSelected.includes(fileName)
        ? prevSelected.filter((name) => name !== fileName)
        : [...prevSelected, fileName]
    );
  };

  useEffect(() => {
    const fetchDocsSubidos = async () => {
      try {
        const axiosInstance = await axiosInstancePromise;
        const response = await axiosInstance.get(`/get-table-general/${'DocumentosSubidos'}`);
        const allRows = response.data.rows || [];
        setData(allRows);
      } catch (error) {
        console.error("Error fetching documentos subidos:", error);
      }
    };
    fetchDocsSubidos();
  }, [setData]);

  const deleteFile = async (fileName) => {
    const confirmDelete = window.confirm(`¿Estás seguro de que deseas eliminar "${fileName}"?`);
    if (!confirmDelete) return;

    try {
      const axiosInstance = await axiosInstancePromise;
      await axiosInstance.post('/soportes-eliminar', { path, fileName });
      alert(`El archivo "${fileName}" ha sido eliminado.`);
      fetchFiles(); // Actualizar la lista
    } catch (error) {
      console.error("Error deleting file:", error);
      alert("No se pudo eliminar el archivo.");
    }
  };

  const goBack = () => {
    if (path) {
      const pathArray = path.replace(basePath, '').split('/').filter(Boolean);
  
      if (pathArray.length > 0) {
        pathArray.pop();
        const newPath = `${basePath}/${pathArray.join('/')}`;
        setPath(newPath); 
      } else {
        setPath(basePath);
      }
    }
  };

  const handleFileUpload = async () => {
    if (!file) return alert("Por favor selecciona un archivo.");
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('newFileName', newFileName || file.name); 
      formData.append('path', path);
      const axiosInstance = await axiosInstancePromise;
      await axiosInstance.post('/soportes-subir', formData, {
        headers: { 'Content-Type': 'multipart/form-data',  },
      });

      alert("Archivo subido exitosamente.");
      setFile(null);
      setNewFileName('');
      fetchFiles();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const getIcon = (item) => {
    if (item.isDir) {
      return <FolderIcon style={{ color: 'orange' }} />;
    }
    const extension = item.name.split('.').pop().toLowerCase();
    if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) {
      return <ImageIcon style={{ color: 'blue' }} />;
    }
    if (['txt', 'md', 'log'].includes(extension)) {
      return <TextSnippetIcon style={{ color: 'green' }} />;
    }
    return <InsertDriveFileIcon style={{ color: 'gray' }} />;
  };

  return (

    <Box sx={styleDocExplorer} >
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Button
          onClick={goBack}
          startIcon={<ArrowBackIcon />}
          disabled={path === basePath || path === ''}
          variant="contained"
        > Atrás </Button>
        <TextField label="Directorio" value={path} onChange={(e) => {setPath(e.target.value);}}
          variant="outlined" size="small" style={{ display: 'none' }}
        />
      </Box>
      <Box sx={{ width: '91%', px: 2, maxHeight: '300px', overflowY: 'auto', border: '1px solid #ccc',
          borderRadius: '4px', bgcolor: '#f9f9f9', mb: 2,
        }}
      >
      {items.map((item, index) => (
      <Box
        key={index}
        sx={{ width: '100%' }}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '4px 0', cursor: item.isDir ? 'pointer' : 'default',
        }}
      >
        <Box
          onClick={() => {
            if (item.isDir) {
              const currentPath = path.startsWith(basePath) ? path : basePath;
              const newPath = `${currentPath}/${item.name}`;
              setPath(newPath);
              localStorage.setItem('pathsop', newPath);
            } else {
              setSelectedFile(`${path}/${item.name}`);
            }
          }}
          style={{ display: 'flex', alignItems: 'center', flex: 1 }}
        >
          {getIcon(item)}
          <Typography style={{ marginLeft: '10px' }}>{item.name}</Typography>
        </Box>
        {!data.some((doc) => doc.Nombre_archivo === item.name) &&
          !item.isDir &&
          !item.isRegistered && (
            <>
              <Checkbox
                checked={selectedFiles.includes(item.name)}
                onChange={() => handleSelectFile(item.name)}
              />
              <DeleteIcon
                style={{ color: 'gray', cursor: 'pointer' }}
                onClick={() => deleteFile(item.name)}
              />
              <DownloadIcon
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => downloadFile(item.name)}
              />
            </>
          )}
        </Box>
        ))}
      </Box>
      <Box sx={{ width: '100%', px: 2, mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', paddingLeft:2 }} gutterBottom>
          Subir Archivos
        </Typography>
        <Box sx={{width: '91%', px: 2, maxHeight: '300px', overflowY: 'auto', border: '1px solid #ccc',
            borderRadius: '4px', bgcolor: '#f9f9f9', marginLeft:1, marginRight:1
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              style={{ display: 'none' }}
              id="upload-file"
            />
            <label htmlFor="upload-file">
              <Button component="span" startIcon={<UploadIcon />} variant="contained" color="secondary" >
                Seleccionar Archivo
              </Button>
            </label>
            <Button sx={{ mt:2}} onClick={handleFileUpload} variant="contained" color="primary" disabled={!file} >
              Subir
            </Button>
          </Box>
          {file && (
            <Box>
              <Typography sx={{ mb:2 }}>
                {file.name}
              <DeleteIcon onClick={() => setFile(null)} color="error" sx={{ marginLeft: 1 }}/>
              </Typography>
            </Box>
          )}
          {file && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%', mb:1 }}>
              <TextField
                label="Guardar como"
                variant="outlined"
                size="small"
                fullWidth
                value={newFileName}
                onChange={(e) => setNewFileName(e.target.value)}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>

  );
};

export default DocumentExplorer;
